import React from 'react';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { useLocale } from 'locale';
import { checkListAmenities } from 'components/unit-page/amenities/config';
import { Amenity } from 'utils/entities';
import { AmenityCheckListItem } from './blocks/amenity-check-list-item';
import { SECURE_ROOM_AMENITIES } from 'components/bulletin-form/constants';
import { mapAmenitiesWithSecure } from './helper';


export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Header = styled(Text.withComponent('h2'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const AmenitiesContainer = styled(Text)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(4),
}));


interface AmenitiesCheckListProps {
  amenities: Record<Amenity, boolean>;
}

const AmenitiesCheckList: React.FunctionComponent<AmenitiesCheckListProps> = (props) => {
  const { t } = useLocale();
  const { amenities } = props;

  const amenitiesList = mapAmenitiesWithSecure({
    list: checkListAmenities,
    amenities,
    t,
    titleKey: 'unitPage.amenities.check.list.title',
    secureRoomAmenities: SECURE_ROOM_AMENITIES,
  });

  return (
    <Root data-auto="amenities-checklist-block">
      <Header weight="bold">
        {t('unitPage.amenities.checklist.header')}
      </Header>
      <AmenitiesContainer>
        {[ ...amenitiesList.active, ...amenitiesList.inactive ].map(
          (itemProps) => (
            <AmenityCheckListItem
              key={itemProps.locator}
              {...itemProps}
            />
          )
        )}
      </AmenitiesContainer>
    </Root>
  );
};

export default React.memo(AmenitiesCheckList);
